<script setup lang="ts">
  import { computed } from "vue";
  import { storeToRefs } from "pinia";
  import NavButton from "@/components/App/NavButton.vue";
  import { useSurveyStore } from "@stores/survey/survey.js";
  import { useSurveyContextStore } from "@stores/survey/surveyContext";
  import { useToastsStore } from "@stores/toastsStore";

  const surveyContextStore = useSurveyContextStore();
  const { context, hasUnsavedChanges, saving } = storeToRefs(surveyContextStore);
  const toasts = useToastsStore();

  const canSave = computed(() => hasUnsavedChanges.value && context.value?.status !== "generating");

  const save = async () => {
    try {
      await surveyContextStore.save(String(useSurveyStore().token));
      toasts.success("Context saved", "Episto AI will use this version from now on.");
    } catch (error) {
      toasts.error("The context was not saved", (error as Error).message);
    }
  };
</script>

<template>
  <NavButton
    data-cy="survey-context-save"
    :can-trigger="canSave"
    :loading="saving"
    :action-function="save" />
</template>
